import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {FEATURE_BULLETS} from './consts';

import styles from './trial-summary-page.module.css';

interface Props {
    daysLeftInTrial: number;
}

export function TrialSummaryActiveState(props: Props) {
    const trialHeading = `Your trial has ${props.daysLeftInTrial} day${
        props.daysLeftInTrial !== 1 ? 's' : ''
    } left.`;

    return (
        <div className={styles['hero-card']}>
            <div className={styles['active-layout']}>
                <Illustration src='trial-expiring' alt='Hourglass' />
                <Stack spacing={24}>
                    <div className={styles['trial-heading']}>
                        <Body isBold={true} useDoyle={true} color='dark'>
                            {trialHeading}
                        </Body>
                    </div>
                    <Body color='dark'>
                        You are in a trial with all Nutshell Enterprise features. Connect with our
                        sales team if you have questions about pricing and tiers.
                    </Body>
                    <div className={styles['bullet-grids']}>
                        <div className={styles['bullet-grid']}>
                            {FEATURE_BULLETS.slice(0, 3).map((bullet) => (
                                <FeatureBullet
                                    key={bullet.title}
                                    icon={bullet.icon}
                                    title={bullet.title}
                                />
                            ))}
                        </div>
                        <div className={styles['bullet-grid']}>
                            {FEATURE_BULLETS.slice(3).map((bullet) => (
                                <FeatureBullet
                                    key={bullet.title}
                                    icon={bullet.icon}
                                    title={bullet.title}
                                />
                            ))}
                        </div>
                    </div>
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        variant='button-primary'
                        size='xlarge'
                        to='/setup/billing/sales'
                        widthFitContent={true}
                    >
                        Upgrade to a paid plan
                    </Link>
                </Stack>
            </div>
        </div>
    );
}

interface FeatureBulletProps {
    icon: React.ComponentType<any>;
    title: string;
}

const FeatureBullet = (props: FeatureBulletProps) => (
    <Stack isHorizontal={true} spacing={8}>
        <props.icon color={colors.blue} size={20} />
        <Body color='dark'>{props.title}</Body>
    </Stack>
);
